import { Box, BoxProps } from "@vinomofo/components";

import styled from "styled-components";

const HamburgerIcon = styled(Box)`
  width: 18px;
  position: relative;
  height: 16px;
  transform: rotate(0deg);
  transition: 0.5s ease-in-out;
  cursor: pointer;

  & span {
    display: block;
    position: absolute;
    height: 2px;
    width: 100%;
    background: ${({ color, theme }) =>
      color ? color : theme.colors.dorianGray};
    border-radius: 6px;
    opacity: 1;
    left: 0;
    transform: rotate(0deg);
    transition: 0.25s ease-in-out;
  }

  & span:nth-child(1) {
    top: 0px;
  }

  & span:nth-child(2),
  & span:nth-child(3) {
    top: 6px;
  }

  & span:nth-child(4) {
    top: 12px;
  }

  &.open span:nth-child(1) {
    top: 12px;
    width: 0%;
    left: 50%;
  }

  &.open span:nth-child(2) {
    transform: rotate(45deg);
  }

  &.open span:nth-child(3) {
    transform: rotate(-45deg);
  }

  &.open span:nth-child(4) {
    top: 12px;
    width: 0%;
    left: 50%;
  }
`;

interface Props extends BoxProps {
  isOpen: boolean;
}

export const HamburgerToggle = ({ isOpen, ...rest }: Props): JSX.Element => {
  return (
    <HamburgerIcon className={isOpen && "open"} {...rest}>
      <span />
      <span />
      <span />
      <span />
    </HamburgerIcon>
  );
};
